import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import Button from 'shared/components/Button';
import Box from 'shared/components/Box';
import {
  patchUser,
  addSteps,
  SERVICE_PROVIDER_STEPS,
  NON_SERVICE_PROVIDER_STEPS
} from 'shared/components/Signup/ducks';

import { getImage } from './utils';
import styles from './styles.module.scss';

class ChoosenRole extends Component {
  state = {
    choosenRole: null
  };

  chooseRole = role => {
    this.setState({ choosenRole: role });
  };

  addSteps = () => {
    let steps = NON_SERVICE_PROVIDER_STEPS;
    if (this.state.choosenRole.value === 3) {
      steps = SERVICE_PROVIDER_STEPS;
    }

    this.props.addSteps(steps);
  };

  render() {
    const { roleChoices, patchUser } = this.props;
    const { choosenRole } = this.state;

    return (
      <div className={styles.chooseRoleWrapper}>
        <div className={classnames('page-title', styles.pageTitle)}>
          Welcome to Unissu.
        </div>
        <div className="page-title-label">
          To help us personalise your experience, please tell us what role you
          play in the industry?
        </div>
        <div className={styles.rolesRow}>
          {roleChoices.map((role, index) => {
            let imageSrc = getImage(role.label);

            return (
              <Box
                key={index}
                image={imageSrc}
                onClickEvent={() => this.chooseRole(role)}
                title={role.label}
                selected={choosenRole === role}
              />
            );
          })}
        </div>
        <Button
          className={styles.nextStepBtn}
          color="primary"
          onClick={() => {
            this.addSteps();
            patchUser({ user_type: choosenRole.value });
          }}
          disabled={choosenRole === null}>
          Next Step
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { users } = state.constants.constants;
  return {
    roleChoices: users.USER_TYPE_CHOICES
  };
};

const mapDispatchToProps = {
  patchUser,
  addSteps
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChoosenRole);
